
export const cmsModules = [
  'main',
  'seo'
]
